import L from 'leaflet';
import { MapContainer, Marker, Polygon, TileLayer } from "react-leaflet";
import { listaCoordenadasTalhoes, obterFitBound } from "../../../../../../../../precisao/mapaFertilidadeResumido/components/tabelaMapas/components/bookFertilidadeResumidoSeparado/components/pageElemento/meta";

//ASSETS
import pin from '../../../../../../../../../../assets/svg/marker.svg';

//PROPS
interface Props {
    talhoes: any[];
    list_pontos: any[];
}

export const MapaAgrupado: React.FC<Props> = ({ talhoes, list_pontos }) => {
    return (
        <MapContainer
            scrollWheelZoom={false}
            dragging={false}
            style={{ width: '750px', height: '279px', borderRadius: 10, overflow: 'hidden' }}
            id={`map${'page_number'}`}
            bounds={obterFitBound(talhoes)}
            zoomControl={false}
            zoom={5}
        >
            <TileLayer
                url='http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'
                maxZoom={20}
                subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            />

            {(listaCoordenadasTalhoes(talhoes) ?? []).map((coord, index) => {
                return (
                    <Polygon
                        key={`${coord?.[index]?.lat}_${index}`}
                        positions={coord}
                        pathOptions={{
                            opacity: 1,
                            color: 'cyan',
                        }}
                    />
                )
            })}

            {(list_pontos ?? []).map((ltdLng, index) => {

                const iconMarker = L.divIcon({
                    html: `
                        <div style="
                            position: relative;
                            width: 30px;
                            height: 30px;
                        ">
                            <img src="${pin}" style="width: 100%; height: 100%;" />
                            <span style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: black;
                            font-weight: 600;
                            font-size: 10px;
                            margin-top: -3px;
                            ">
                            ${ltdLng?.ponto}
                            </span>
                        </div>
                    `,
                    className: '',
                    iconSize: [30, 30],
                    iconAnchor: [15, 30],
                });

                return <Marker key={Number(ltdLng?.[0]) + '_' + index} position={ltdLng} icon={iconMarker} />

            })}

        </MapContainer>
    )
}